import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { UpdatePageSchemaRequest } from "@shopexperts/shared";

interface UpdateSchemaParams {
  id: number;
  data: UpdatePageSchemaRequest;
}

export function useUpdateSchema() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: ({ id, data }: UpdateSchemaParams) => 
      api.admin.pages.updateSchema({ params: { id }, body: data }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'page-schemas'] });
      // The page editor reads the schema through useSchema's per-id key, which
      // would otherwise keep serving the pre-save fields for its whole staleTime.
      queryClient.invalidateQueries({ queryKey: ['admin', 'page-schema', variables.id] });
      toaster.create({
        title: "Schema updated successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      console.error('[useUpdateSchema] Error:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message ||
        'An error occurred while updating the schema.';
      
      toaster.create({
        title: "Failed to update schema",
        description: errorMessage,
        type: "error",
      });
    },
  });
}

